import { io } from 'socket.io-client';
import configs from "../configs/config";

/** @type {import('socket.io-client').Socket} */
const socket = io(`${configs.useSsl ? "wss" : "ws"}://${configs.host}:${configs.port}`, {
    autoConnect: false,
    transports: ["websocket"]
});

export default socket;